import { InjectionToken } from '@angular/core';
import { DynamicTabConfig } from './core/services/dyamic-tab.service';

export const DYNAMIC_TAB_CONFIG = new InjectionToken<DynamicTabConfig>('DYNAMIC_TAB_CONFIG');
